// components
import {
  styled,
  Box,
  BoxProps,
  Typography,
  TypographyProps,
  Chip,
  ChipProps
} from '@mui/material';

export const StyledTopInfoContainer = styled(Box)<BoxProps>(({ theme }) => ({
  backgroundColor: theme.vars.palette.surface.bright,
  margin: theme.spacing(-4, -6, 4, -6),
  padding: theme.spacing(4, 6),
  display: 'flex',
  gap: theme.spacing(4)
}));

export const StyledValueTypography = styled(Typography)<TypographyProps>(
  () => ({
    maxHeight: '210px',
    overflow: 'auto'
  })
);

export const StyledChip = styled(Chip)<ChipProps>(() => ({
  '& .MuiChip-label': {
    lineHeight: '12px'
  }
}));
